export default {
  en: {
    supplier: {
      slide1Title: 'Build trust with clients. Fast.',
      slide1Li1: 'Speed up security reviews and close deals faster',
      slide1Li2: 'Know exactly where you are in the review process',
      slide1Li3: 'Never complete a questionnaire from scratch again',
      slide2Title: 'Save time on future assessments',
      slide2Body1: 'No more duplicate spreadsheets or repetitive work.',
      slide2Body2:
        'Build a single risk profile, share with any client, and complete assessments up to 6 weeks faster.',
      slide3Title: 'Keep up momentum and know exactly where you are in the process.',
      slide3Body1:
        'No chasing, no guesswork, just everything you need for a successful security review, all in one place.',
      slide3Body2: "And once you're finished, you can share your profile with other clients.",
      slide3CTA: 'Get started',
    },
    client: {
      slide1Title: 'Connect, visualise and protect your supply chain',
      slide1Body:
        'Instantly identify concentration risks, gain visual insights, and stay on top of emerging threats.',
      slide2Title: 'Reduce the time it takes to review suppliers',
      slide2Li1: 'Gain instant access to an 8,000+ supplier network',
      slide2Li2: 'Keep your supplier security data all in one place',
      slide2Li3:
        'Suppliers use the same profile with many clients, giving them more reasons to keep it up-to-date',
      slide3Title: 'Identify non-compliance quickly and easily',
      slide3Body1: 'Compare supplier assessment results against your own policies and procedures.',
      slide3Body2: 'Spot risks before they become problems.',
      slide3CTA: 'Get started',
    },
  },
};
